import { Spinner } from "../components/Layout";
import '../LoaderComponent/LoaderComponent.css'

function LoaderComponent({color = '#367c2b' }) {
  return (
    <div className="loader-container h-[670px]">
      <div className="flex w-auto justify-center min-h-[650px] items-center relative flex-col">
        <Spinner
          size={60}
          className="pt-6"
          color={color}
        />
        <span className="mt-3">Your request is being processed, please wait..🚜🚜 </span>
      </div>
    </div>
  );
}

export default LoaderComponent;
